import React from "react"
import "./styles.less"
import nl2br from "../../utils/nl2br"
import { Link } from "gatsby"

const CTABox = ({ data }) => {
  const { sectionTitle, buttonLink, buttonLabel, description } = data
  return (
    <div className="cta-box-section">
      <div className="container">
        <div className="row">
          <div className="col-md-8">
            <h2 className="mt-0">{sectionTitle}</h2>
            <p>{nl2br(description)}</p>
            <Link to={buttonLink} className="btn btn-primary">
              {buttonLabel}
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CTABox
